<nz-modal [nzWrapClassName]="'feature-guide-modal'" *ngIf="slides.length > 0" [(nzVisible)]="isVisible" [nzFooter]="null" [nzTitle]="undefined"
    [nzWidth]="950" (nzOnCancel)="closeModal()" nzCentered [nzBodyStyle]="{ padding: '0', background: 'transparent' }">
    <ng-container *nzModalContent>

        <div class="modal-body-content">
            <div class="carousel-arrow left" *ngIf="slides.length > 1" (click)="prevSlide()">
                <img [src]="'assets/left_arrow_grey.svg'" alt="Previous Slide">
            </div>
            <div class="carousel-arrow right" *ngIf="slides.length > 1" (click)="nextSlide()">
                <img [src]="'assets/right_arrow_grey.svg'" alt="Next Slide">
            </div>
            <div class="coverflow-container">
                <div class="coverflow-card" *ngFor="let slide of slides; let i = index"
                    [ngClass]="[getCardClass(i), slide.type === 'NEW_FEATURE' ? 'new-feature-card' : 'product-card']"
                    (click)="goToSlide(i)">

                    <button class="close-btn" (click)="closeModal()">
                        <span nz-icon nzType="close" nzTheme="outline"></span>
                    </button>
                    <ng-container *ngIf="slide.type === 'NEW_FEATURE'; else productTemplate">
                        <div class="modal-badge" *ngIf="getCardClass(i) === 'card-center'">
                            <img [src]="'assets/jewel.png'" class="feature-image"> {{ slide.badge }}
                        </div>
                        <h2 class="main-title-feature">{{ slide.title }}</h2>
                        <p class="sub-title">{{ slide.subtitle }}</p>

                        <div class="carousel-split-area">
                            <div class="text-points">
                                <div class="point-item" *ngFor="let point of slide.points; let pointIdx = index"
                                    [class.active]="pointIdx === subIndices[i]">
                                    <span class="vertical-line" *ngIf="pointIdx === subIndices[i]"></span>
                                    <div class="point-title">{{ point.name }}</div>
                                    <div class="point-desc">{{ point.subTexts[0] }}</div>
                                </div>
                            </div>
                            <div class="image-preview">
                                <div class="img-loading-wrapper">
                                    <div class="loading-spinner"
                                        *ngIf="!isImageLoaded(slide.points[subIndices[i]]?.imageUrl)">
                                        <span nz-icon nzType="loading" nzTheme="outline"></span>
                                    </div>
                                    <img [src]="slide.points[subIndices[i]]?.imageUrl" alt="Feature Preview"
                                        [class.loaded]="isImageLoaded(slide.points[subIndices[i]]?.imageUrl)"
                                        (load)="onImageLoad(slide.points[subIndices[i]]?.imageUrl)">
                                </div>
                                <div class="blue-gradient-overlay"></div>
                            </div>
                        </div>
                        <div class="custom-footer">
                            <div class="buttons">
                                <button nz-button nzType="primary"
                                    style="background-color: #007BC0; width: 142px; height: 46px;"
                                    (click)="onCheck(slide.navigationUrl)">去查看</button>
                                <button nz-button nzType="default"
                                    style="background-color: #D9D9D9; width: 142px; height: 46px;"
                                    (click)="closeModal()">我知道了</button>
                            </div>
                            <div class="checkbox-wrapper">
                                <label nz-checkbox [(ngModel)]="dontShowForSevenDays"
                                    (ngModelChange)="hideModal()">七天内不再显示</label>
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #productTemplate>
                        <div class="modal-badge" *ngIf="getCardClass(i) === 'card-center'">
                            <img [src]="'assets/product.png'" class="product-image"> {{ slide.badge }}
                        </div>

                        <div class="product-layout-content">
                            <div class="points-list">
                                <div class="product-header">
                                    <h2 class="main-title-product">{{ slide.title }}</h2>
                                    <div class="sub-title-wrapper">
                                        <span class="vertical-line"></span>
                                        <p class="sub-title">{{ slide.subtitle }}</p>
                                    </div>
                                </div>

                                <div class="point-items">
                                    <div class="point-item" *ngFor="let point of slide.points">
                                        <div class="point-title">• {{ point.name }}</div>
                                        <div class="point-desc" *ngFor="let text of point.subTexts">
                                            {{ text }}
                                        </div>
                                    </div>
                                </div>

                                <div class="new-product-footer">
                                    <div class="checkbox-wrapper">
                                        <label nz-checkbox [(ngModel)]="dontShowForSevenDays"
                                            (ngModelChange)="hideModal()">七天内不再显示</label>
                                    </div>
                                    <button nz-button nzType="primary"
                                        style="background-color: #007BC0; width: 142px; height: 46px;"
                                        (click)="onCheck(slide.navigationUrl)">查看更多</button>
                                </div>
                            </div>

                            <div class="product-image">
                                <div class="img-loading-wrapper">
                                    <div class="loading-spinner" *ngIf="!isImageLoaded(slide.newProductImage)">
                                        <span nz-icon nzType="loading" nzTheme="outline"></span>
                                    </div>
                                    <img [src]="slide.newProductImage" alt="Product Preview"
                                        [class.loaded]="isImageLoaded(slide.newProductImage)"
                                        (load)="onImageLoad(slide.newProductImage)">
                                </div>
                            </div>
                        </div>

                    </ng-template>

                    <div class="card-overlay" *ngIf="getCardClass(i) !== 'card-center'"></div>
                </div>
            </div>

            <div class="custom-dots" *ngIf="slides.length > 1">
                <span *ngFor="let slide of slides; let i = index" class="dot" [class.active]="i === currentIndex"
                    (click)="goToSlide(i)">
                </span>
            </div>
        </div>
    </ng-container>

    <!-- <ng-template #modalFooter>
    </ng-template> -->
</nz-modal>
